export default __webpack_public_path__ + "img/donges.04d662e9.jpg";